'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Avatar component with support for fallback images.
 */
var Avatar = function (_React$Component) {
  (0, _inherits3.default)(Avatar, _React$Component);

  function Avatar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      usingFallback: false
    }, _this.onError = function () {
      if (!_this.state.usingFallback) {
        _this.setState({ usingFallback: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // When we receive new props, reset the fallback.
      if (this.props.url !== nextProps.url && this.state.usingFallback === true) {
        this.setState({ usingFallback: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          size = _props.size,
          style = _props.style,
          fallback = _props.fallback,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['url', 'size', 'style', 'fallback', 'className']);
      var usingFallback = this.state.usingFallback;

      return _react2.default.createElement('img', (0, _extends3.default)({
        src: usingFallback && fallback ? fallback : url,
        onError: this.onError,
        className: (0, _classnames2.default)('Avatar', className),
        style: (0, _extends3.default)({ width: size, height: size }, style)
      }, props));
    }
  }]);
  return Avatar;
}(_react2.default.Component);

exports.default = Avatar;


Avatar.propTypes = {
  url: _propTypes2.default.string,
  size: _propTypes2.default.number,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  fallback: _propTypes2.default.string
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Avatar/index.js
// module id = 100
// module chunks = 0